import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./Card.module.css";

const Card = ({
  children,
  type,
  ariaLive,
  ariaRelevant,
  isTwoColumnFinalRow = false,
  isThreeColumnFinalRow = false,
  ...other
}) => {
  const classType = {
    main: "main",
    half: "half",
    container: "container",
    aside: "aside",
    bottom: "bottom",
    mainListingPage: "mainListingPage",
    getInTouch: "getInTouch",
    homepageTopicWrapper: "homepageTopicWrapper",
  };

  return (
    <div
      {...other}
      className={classnames(styles.card, styles[classType[type]], {
        [styles.twoColumnFinalRow]: isTwoColumnFinalRow,
        [styles.threeColumnFinalRow]: isThreeColumnFinalRow,
      })}
      aria-live={ariaLive || null}
      aria-relevant={ariaRelevant || null}
      data-testid="card"
    >
      {children}
    </div>
  );
};

export default Card;

Card.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  ariaLive: PropTypes.string,
  ariaRelevant: PropTypes.string,
  isTwoColumnFinalRow: PropTypes.bool,
  isThreeColumnFinalRow: PropTypes.bool,
};
